/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Вью отвечающая за попап с фильтрами в подборе для авто
   */
  app.ParamPopupFilter = app.View.extend({
    additionalOptions: ['filterValues', 'collection'],
    events: {
      'change .scrollable input[type=checkbox]': 'handleCheckBoxChange',
    },
    currentFilterKey: '',
    /** @inheritDoc */
    run: function () {
      this.initPopup();
      this.paramCheckboxTemplate = app.helpers.TemplateHelper.getTemplate('#param-checkbox-template');
    },
    /**
     * Инициализация als.Popup
     */
    initPopup: function (){
      this.popup = new als.Popup(this.$el);
      this.popup.addEventListener(als.Popup.EventType.BEFORE_OPEN, this.handleBeforeOpen.bind(this));
      this.popup.addEventListener(als.Popup.EventType.BEFORE_CLOSE, this.handleBeforeClose.bind(this));
    },
    /**
     * Выполняется перед открытием
     * - позиционирует попап
     * - тригерит событие для добавления класса активному фильтру
     */
    handleBeforeOpen: function () {
      this.$el.css(app.helpers.PopupPositioningHelper.positionLeftOfOpener(
        this.$opener,
        this.$el,
        true)
      );
      this.trigger('toggle-active-filter', true, this.currentFilterKey);
    },
    /**
     * Выполняется перед закрытием
     * - Приводит к пустой строке текущий ключ фильтр
     * - Тригерит событие для удаления класса у активного фильтра
     */
    handleBeforeClose: function () {
      this.trigger('toggle-active-filter', false, this.currentFilterKey);
      this.currentFilterKey = '';
    },
    /**
     * Рендер
     * @param {Object} filterData данные фильтра
     */
    render: function (filterData) {
      var filterType = filterData.class_name,
        html = '';
      switch (filterType) {
        case 'ColoredCheckboxList':
        case 'HasOne':
        case 'HasMany':
        case 'AggMinQty':
        case 'AggSupplyPeriod':
        case 'Specification':
          html = this.paramCheckboxTemplate({
            values: filterData.values,
            filterKey: this.currentFilterKey,
          });
          break;
        default:
          this.handlePopupClose();
      }
      this.$('.filters-section').html(html);
    },
    /**
     * Хендлер изменения чекбоксов
     * @param {jQuery.Event} event Событие
     */
    handleCheckBoxChange: function (event) {
      var $target = $(event.currentTarget),
        filterId = $target.data('filterId'),
        filterKey = this.currentFilterKey,
        currentFilterObj = this.collection.getFilter(),
        filterObj = {};
      if ($target.prop('checked')) {
        filterObj[filterKey] = [filterId];
        filterObj = app.helpers.ObjectHelper.mergeDeep(currentFilterObj, filterObj);
      } else {
        filterObj = currentFilterObj;
        filterObj[filterKey] = filterObj[filterKey].filter(function (val) {
          return String(val) !== String(filterId);
        });
      }

      Backbone.trigger('backbone-filter-apply', event, filterObj);
    },
    /**
     * Хендлер закрытия попапа
     */
    handlePopupClose: function () {
      this.popup.close();
    },
    /**
     * Хендлер открытия попапа
     */
    handlePopupOpen: function ($opener, filterData, filterKey) {
      if (!this.popup.isClosed() && this.currentFilterKey === filterKey) {
        return;
      }
      this.currentFilterKey = filterKey;
      this.$opener = $opener;
      this.render(filterData);
      setTimeout(this.popup.open.bind(this.popup), 0);
    },
  });
})();

}.call(window));